import { __assign as t } from "./index103.mjs";
import { WHITE_SPACE_REGEX as x } from "./index104.mjs";
function M(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var n = e.split(x).filter(function(u) {
    return u.length > 0;
  }), c = [], o = 0, i = n; o < i.length; o++) {
    var m = i[o], g = m.split("/");
    if (g.length === 0)
      throw new Error("Invalid number skeleton");
    for (var p = g[0], s = g.slice(1), r = 0, l = s; r < l.length; r++) {
      var a = l[r];
      if (a.length === 0)
        throw new Error("Invalid number skeleton");
    }
    c.push({ stem: p, options: s });
  }
  return c;
}
function E(e) {
  return e.replace(/^(.*?)-/, "");
}
var h = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, w = /^(@+)?(\+|#+)?[rs]?$/g, S = /(\*)(0+)|(#+)(0+)|(0+)/g, D = /^(0+)$/;
function d(e) {
  var n = {};
  return e[e.length - 1] === "r" ? n.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (n.roundingPriority = "lessPrecision"), e.replace(w, function(c, o, i) {
    return typeof i != "string" ? (n.minimumSignificantDigits = o.length, n.maximumSignificantDigits = o.length) : i === "+" ? n.minimumSignificantDigits = o.length : o[0] === "#" ? n.maximumSignificantDigits = o.length : (n.minimumSignificantDigits = o.length, n.maximumSignificantDigits = o.length + (typeof i == "string" ? i.length : 0)), "";
  }), n;
}
function v(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function F(e) {
  var n;
  if (e[0] === "E" && e[1] === "E" ? (n = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (n = {
    notation: "scientific"
  }, e = e.slice(1)), n) {
    var c = e.slice(0, 2);
    if (c === "+!" ? (n.signDisplay = "always", e = e.slice(2)) : c === "+?" && (n.signDisplay = "exceptZero", e = e.slice(2)), !D.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    n.minimumIntegerDigits = e.length;
  }
  return n;
}
function y(e) {
  var n = {}, c = v(e);
  return c || n;
}
function _(e) {
  for (var n = {}, c = 0, o = e; c < o.length; c++) {
    var i = o[c];
    switch (i.stem) {
      case "percent":
      case "%":
        n.style = "percent";
        continue;
      case "%x100":
        n.style = "percent", n.scale = 100;
        continue;
      case "currency":
        n.style = "currency", n.currency = i.options[0];
        continue;
      case "group-off":
      case ",_":
        n.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        n.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        n.style = "unit", n.unit = E(i.options[0]);
        continue;
      case "compact-short":
      case "K":
        n.notation = "compact", n.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        n.notation = "compact", n.compactDisplay = "long";
        continue;
      case "scientific":
        n = t(t(t({}, n), { notation: "scientific" }), i.options.reduce(function(s, r) {
          return t(t({}, s), y(r));
        }, {}));
        continue;
      case "engineering":
        n = t(t(t({}, n), { notation: "engineering" }), i.options.reduce(function(s, r) {
          return t(t({}, s), y(r));
        }, {}));
        continue;
      case "notation-simple":
        n.notation = "standard";
        continue;
      // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
      case "unit-width-narrow":
        n.currencyDisplay = "narrowSymbol", n.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        n.currencyDisplay = "code", n.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        n.currencyDisplay = "name", n.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        n.currencyDisplay = "symbol";
        continue;
      case "scale":
        n.scale = parseFloat(i.options[0]);
        continue;
      case "rounding-mode-floor":
        n.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        n.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        n.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        n.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        n.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        n.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        n.roundingMode = "halfExpand";
        continue;
      // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
      case "integer-width":
        if (i.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        i.options[0].replace(S, function(s, r, l, a, u, f) {
          if (r)
            n.minimumIntegerDigits = l.length;
          else {
            if (a && u)
              throw new Error("We currently do not support maximum integer digits");
            if (f)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (D.test(i.stem)) {
      n.minimumIntegerDigits = i.stem.length;
      continue;
    }
    if (h.test(i.stem)) {
      if (i.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      i.stem.replace(h, function(s, r, l, a, u, f) {
        return l === "*" ? n.minimumFractionDigits = r.length : a && a[0] === "#" ? n.maximumFractionDigits = a.length : u && f ? (n.minimumFractionDigits = u.length, n.maximumFractionDigits = u.length + f.length) : (n.minimumFractionDigits = r.length, n.maximumFractionDigits = r.length), "";
      });
      var m = i.options[0];
      m === "w" ? n = t(t({}, n), { trailingZeroDisplay: "stripIfInteger" }) : m && (n = t(t({}, n), d(m)));
      continue;
    }
    if (w.test(i.stem)) {
      n = t(t({}, n), d(i.stem));
      continue;
    }
    var g = v(i.stem);
    g && (n = t(t({}, n), g));
    var p = F(i.stem);
    p && (n = t(t({}, n), p));
  }
  return n;
}
export {
  _ as parseNumberSkeleton,
  M as parseNumberSkeletonFromString
};
